<template>
  <div class="intensive-test__answer">
    <div class="intensive-answer _mb-4 d-flex" @click="checkAnswer()">
      <div
        class="intensive-answer__check-wrap _mr-2"
        :class="{
          'intensive-answer__check-wrap_is_correct':
            checked && answer.is_correct,
          'intensive-answer__check-wrap_is_error':
            checked && !answer.is_correct,
        }"
      >
        <div class="intensive-answer__icon" v-if="checked">
          <svg
            v-if="answer.is_correct"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.3333 4L5.99996 11.3333L2.66663 8"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <svg
            v-if="!answer.is_correct"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 4L4 12M4 4L12 12"
              stroke="#DC582A"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <div class="_my-auto _fs-16 _lh-24 _tc-dark">
        {{ getTranslate(answer).title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Answer',
  data: () => ({
    checked: false,
  }),
  props: {
    answer: Object,
    aInd: Number,
  },
  methods: {
    getTranslate(item) {
      return item.translates[0]
    },
    checkAnswer() {
      this.checked = true
      if (!this.answer.is_correct) {
        this.$emit('blockQuestion')
      }
      if (this.answer.is_correct) {
        this.$emit('addCorrectAnswer')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.intensive-answer {
  &__check-wrap {
    flex-shrink: 0;
    position: relative;
    border: 1px solid #c7c9c7;
    border-radius: 8px;
    background-color: #fff;
    width: 26px;
    height: 26px;
    overflow: hidden;

    &_is_correct {
      background-color: #77bb2f;
      border-color: #77bb2f;
    }

    &_is_error {
      border-color: #dc582a;
    }
  }

  &__icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
